import { Typography } from "@circle-react-uikit/Typography";

interface LineItemSmProps {
  amount?: string;
  color?: string;
  title: string;
}

export const LineItemSm = ({
  title,
  amount,
  color = "text-default",
}: LineItemSmProps) => (
  <div className="mb-2 flex items-start justify-between">
    <Typography.BodySm color="text-light">{title}</Typography.BodySm>
    <Typography.BodySm color={color}>{amount}</Typography.BodySm>
  </div>
);
